import { AxiosInstance } from 'axios';
import { AttendanceContactDeadlineRepository } from '@/model/repository/manager/parentContacts/AttendanceContactDeadlineRepository';

export default (Repository: AxiosInstance) =>
  (resource: string): AttendanceContactDeadlineRepository => ({
    detail(facilityId) {
      return Repository.get(`${resource}/${facilityId}`);
    },
    update(payload) {
      return Repository.post(resource, payload);
    },
  });
